import MassiaDapFromController from './massia-dap.form.controller';
import MassiaDapForm from './massia-dap.form.html';

export default {
	template: MassiaDapForm,
	controller: MassiaDapFromController
};
